export const COMPANY_ADDONS = {
    DATABASE: "database",
    AUDIOPWA: "audiopwa",
    LIVETRANSLATION: "livetranslation",
    CHATBOT: "chatbot",
    ACTIVITIES: "activities",
    NOTIFICATIONS: "notifications",
    EXPORTUSERS: "exportusers",
    VIDEO: "video",
    ANALYTICS: "analytics",
    REVIEWS: "reviews",
} as const;

export function hasAddon(company: { addons: string[] } | undefined, addon: string): boolean {
    return company?.addons?.includes(addon) ?? false;
}

export function hasAddonOrOwner(
    user:
        | { isOwner?: boolean; companyId?: string | null; cmpany?: { id?: string; addons: string[] } }
        | null
        | undefined,
    addon: string,
): boolean {
    if (user?.isOwner) {
        return true;
    }
    if (!user?.companyId || user.cmpany?.id !== user.companyId) {
        return false;
    }
    return hasAddon(user.cmpany, addon);
}
